(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compatibility-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const searchInput = document.getElementById('searchInput');
    const compatibilityItems = document.querySelectorAll('.compatibility-list-item');
    const noResults = document.getElementById('noResults');
    const compatibilityListItems = document.getElementById('compatibilityListItems');
    
    if (searchInput && compatibilityItems.length > 0) {
      searchInput.addEventListener('input', function() {
        const searchTerm = this.value.toLowerCase().trim();
        let visibleItems = 0;
        
        compatibilityItems.forEach(function(item) {
          const brand = item.getAttribute('data-brand').toLowerCase();
          const model = item.getAttribute('data-model').toLowerCase();
          
          if (brand.includes(searchTerm) || model.includes(searchTerm)) {
            item.classList.remove('hidden');
            visibleItems++;
          } else {
            item.classList.add('hidden');
          }
        });
        
        if (searchTerm && visibleItems === 0) {
          noResults.classList.add('show');
          compatibilityListItems.style.display = 'none';
        } else {
          noResults.classList.remove('show');
          compatibilityListItems.style.display = 'grid';
        }
        
        if (!searchTerm) {
          compatibilityItems.forEach(function(item) {
            item.classList.remove('hidden');
          });
          noResults.classList.remove('show');
          compatibilityListItems.style.display = 'grid';
        }
      });
    }

    // for accordion
    const wrapper = document.querySelector(".compatibility-list-wrapper.collapse");
    const header = document.querySelector(".compatibility-list-title-wrapper");

    // Accordion should run only on product page
    if (!wrapper || !header) return;

    header.addEventListener("click", () => {
      header.classList.toggle("active");
      wrapper.classList.toggle("open");

      if (wrapper.classList.contains("open")) {
        wrapper.style.maxHeight = wrapper.scrollHeight + "px";
      } else {
        wrapper.style.maxHeight = "0";
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const initFeaturedCollection = () => {
      const searchBlocks = document.querySelectorAll('[data-search-block-id]');

      searchBlocks.forEach((block) => {
        const url = block.dataset.fetchUrl;
        const limit = parseInt(block.dataset.limit, 10) || 6;
        const list = block.closest('motion-list');
        if (!url || !list) return;

        // Prevent multiple fetches if already processing (though we remove it later)
        if (block.hasAttribute('data-processed')) return;
        block.setAttribute('data-processed', 'true');

        fetch(url)
          .then((response) => response.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const fetchedGrid = doc.querySelector('.product-grid, .card-grid, #main-collection-product-grid') || doc;
            let cards = [];

            // Use a more specific selector if possible, or filter to ensure we get direct entries
            const allCards = Array.from(fetchedGrid.querySelectorAll('.product-card, .card'));

            // Filter out any nested cards (unlikely but possible)
            cards = allCards.filter((card) => !card.closest('.product-card .card'));

            if (cards.length === 0) {
              // Fallback to searching the whole doc if grid finding failed
              cards = Array.from(doc.querySelectorAll('.product-card'));
            }

            if (cards.length > 0) {
              const frag = document.createDocumentFragment();

              // Enforce limit strictly
              const cardsToShow = cards.slice(0, limit);

              cardsToShow.forEach((card) => {
                frag.appendChild(card);
              });

              // Remove the block before appending to avoid any layout shifts or interference
              block.remove();
              list.appendChild(frag);

              // Custom title logic for search_parameter blocks
              if (url.includes('filter.v.option')) {
                const filterParts = url.split('filter.v.option.');
                if (filterParts.length > 1) {
                  const filterSegment = filterParts[1];
                  const valuePart = filterSegment.split('=')[1];
                  if (valuePart) {
                    let variantOptionValue = valuePart.split('&')[0];
                    try {
                      variantOptionValue = decodeURIComponent(variantOptionValue);
                      // Optional: Replace + with space if decodeURIComponent doesn't handle it for query params
                      variantOptionValue = variantOptionValue.replace(/\+/g, ' ');

                      const appendedCards = list.querySelectorAll('.product-card');
                      // We only want to target the new cards we just appended.
                      // Since we appended to 'list', we can try to narrow down or just update all
                      // (though updating all might be overkill if there were existing ones, but here it's likely fresh or append).
                      // However, 'cardsToShow' is our reference.
                      cardsToShow.forEach((card) => {
                        // The card element is now in the DOM. We need to find its title.
                        const titleEl = card.querySelector('.product-card__title');
                        if (titleEl) {
                          const currentTitle = titleEl.textContent.trim();
                          if (!currentTitle.includes(' - ' + variantOptionValue)) {
                            titleEl.textContent = currentTitle + ' - ' + variantOptionValue;
                          }
                        }
                      });
                    } catch (e) {
                      console.error('Error decoding variant option:', e);
                    }
                  }
                }
              }
            }
          })
          .catch((e) => console.error('Error fetching search results:', e));
      });
    };

    initFeaturedCollection();
    document.addEventListener('shopify:section:load', initFeaturedCollection);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const initFC = () => {
      const searchBlocks = document.querySelectorAll('[data-search-block-id]:not([data-processed])');
      searchBlocks.forEach((block) => {
        block.setAttribute('data-processed', 'true');
        let url = block.dataset.fetchUrl;
        const limit = parseInt(block.dataset.limit) || 6;
        const list = block.closest('motion-list');
        const slider = block.closest('slider-element');
        const tabPanel = block.closest('[role="tabpanel"]');

        if (!url || !list) return;

        // Optimize fetch with Section Rendering API
        if (url.includes('/collections/') || url.includes('/products/')) {
          // Note: /products/ usually doesn't map to main-collection, but user logic focuses on collection/search.
          // Defaulting to main-collection for collections.
          url += (url.includes('?') ? '&' : '?') + 'section_id=main-collection';
        } else if (url.includes('/search')) {
          url += (url.includes('?') ? '&' : '?') + 'section_id=main-search';
        }

        const refreshSlider = () => {
          if (slider && typeof slider.reset === 'function') {
            slider.reset();
            if (typeof slider.updateButtons === 'function') slider.updateButtons();
          }
        };

        fetch(url)
          .then((res) => res.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const grid = doc.querySelector('.product-grid, .card-grid, #main-collection-product-grid') || doc;
            const cards = Array.from(grid.querySelectorAll('.product-card, .card'));

            if (cards.length > 0) {
              block.remove();
              const frag = document.createDocumentFragment();

              const safeLimit = Math.max(0, parseInt(limit, 10));
              const cardsToShow = cards.slice(0, safeLimit);
              cardsToShow.forEach((card) => frag.appendChild(card));
              list.appendChild(frag);

              // Custom title logic for search_parameter blocks
              if (url.includes('filter.v.option')) {
                const filterParts = url.split('filter.v.option.');
                if (filterParts.length > 1) {
                  const filterSegment = filterParts[1];
                  const valuePart = filterSegment.split('=')[1];
                  if (valuePart) {
                    let variantOptionValue = valuePart.split('&')[0];
                    try {
                      variantOptionValue = decodeURIComponent(variantOptionValue);
                      variantOptionValue = variantOptionValue.replace(/\+/g, ' ');

                      cardsToShow.forEach((card) => {
                        const titleEl = card.querySelector('.product-card__title');
                        if (titleEl) {
                          const currentTitle = titleEl.textContent.trim();
                          if (!currentTitle.includes(' - ' + variantOptionValue)) {
                            titleEl.textContent = currentTitle + ' - ' + variantOptionValue;
                          }
                        }
                      });
                    } catch (e) {
                      console.error('Error decoding variant option:', e);
                    }
                  }
                }
              }

              refreshSlider();

              if (tabPanel) {
                const observer = new MutationObserver((mutations) => {
                  if (!tabPanel.hidden) {
                    setTimeout(refreshSlider, 100);
                  }
                });
                observer.observe(tabPanel, { attributes: true, attributeFilter: ['hidden'] });
              }
            }
          })
          .catch((e) => console.error('FC Search Error:', e));
      });
    };

    // Run on load
    document.addEventListener('DOMContentLoaded', initFC);
    document.addEventListener('shopify:section:load', initFC);

    // Poll for late elements
    let attempts = 0;
    const interval = setInterval(() => {
      initFC();
      attempts++;
      if (attempts > 20) clearInterval(interval);
    }, 500);
  })();

  } catch(e) { console.error(e); }
})();
})();
